import { Component, EventEmitter, OnInit, OnDestroy, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { GoogleMapsService } from '../../../services/google-maps.service';
import { GoogleMapComponent } from '../../../common-components/google-map/google-map.component';

@Component({
  selector: 'app-modal-building',
  templateUrl: './modal-building.component.html',
  styleUrls: ['./modal-building.component.scss'],
})
export class ModalBuildingComponent implements OnInit, OnDestroy {
  @Output()
  sendNewAddress = new EventEmitter<any>();

  @ViewChild('googleMapRef', { static: false }) googleMapRef!: GoogleMapComponent;

  isoCode;
  globalLatitud;
  globalLongitud;
  marker: boolean = false;
  buildingId: any;
  latitud;
  longitud;
  zoom: number;
  address: string;
  statusButtonSave: boolean = false;
  possibleAddresses: any[] = [];
  searchAddress:string = null; 
  searching = null;

  constructor(private modalService: NgbModal,
              private googleMapsService: GoogleMapsService,
              private toastr: ToastrService,
              private cdr: ChangeDetectorRef) {}

  async ngOnInit() {
    this.statusButtonSave = true;
    try {
      await this.googleMapsService.loadGoogleMaps();
    } catch (error) {
      console.error('Error loading Google Maps:', error);
    }
  }

  ngOnDestroy(): void {}

  setCountry(latitud, longitud, isoCode, id?) {
    this.statusButtonSave = true;
    this.buildingId = id;
    this.isoCode = isoCode;
    if (this.buildingId) {
      this.marker = true;
      this.latitud = parseFloat(latitud);
      this.longitud = parseFloat(longitud);
      this.globalLatitud = this.latitud;
      this.globalLongitud = this.longitud;
      this.zoom = 18;
      this.getAddress(this.latitud, this.longitud);
    } else {
      this.marker = false;
      this.latitud = parseFloat(latitud);
      this.longitud = parseFloat(longitud);
      this.zoom = 8;
      this.globalLatitud = this.latitud;
      this.globalLongitud = this.longitud;
    }
  }

  autocompleteAddress(selecter:NgSelectComponent, input:HTMLElement, from:string) {
    clearInterval(this.searching);
    if(this.searchAddress === null || this.searchAddress === '') return;
    this.searching = setTimeout(async ()=>{
      try {
        const results = await this.googleMapsService.getPlacePredictionsNew(this.searchAddress);
        this.possibleAddresses = results;
        this.openDropDown(selecter, input);
        if(from == 'button' && results.length > 0) this.selectAdressByGoogle(results[0]);
      } catch (e) {
        try {
          const result = await this.googleMapsService.geocodeAddressComplete(this.searchAddress);
          this.possibleAddresses = [result];
          this.openDropDown(selecter, input);
          if(from == 'button') this.selectAdressByGoogle(result);
        } catch (geocodeError) {
          if(this.searching) clearInterval(this.searching);
        }
      }
    }, from === 'selecter' ? 1000 : 100);
  }

  async selectAdressByGoogle(item){
    try {
      if (item && item.place_id) {
        const details = await this.googleMapsService.fetchPlaceDetails(item.place_id);
        this.searchAddress = details.formattedAddress;
        this.address = details.formattedAddress;
        this.possibleAddresses = [];
        this.latitud = details.lat;
        this.longitud = details.lng;
        this.zoom = 16;
        this.marker = true;
        
        this.cdr.detectChanges();
        this.statusButtonSave = false;
        return;
      }
      if (item && item.geometry?.location) {
        this.searchAddress = item.formatted_address;
        this.address = item.formatted_address;
        this.possibleAddresses = [];
        this.latitud = item.geometry.location.lat();
        this.longitud = item.geometry.location.lng();
        this.zoom = 16;
        this.marker = true;
        
        this.cdr.detectChanges();
        this.statusButtonSave = false;
      }
    } catch (error) {
      this.toastr.error('No fue posible obtener detalles del lugar');
    }
  }
  onLocationSelected(e: { lat: number; lng: number; address: string }) {
    if (!e) return;
    this.latitud = e.lat;
    this.longitud = e.lng;
    this.address = e.address;
    this.marker = true;
    this.zoom = 18;
    this.statusButtonSave = false;
    this.cdr.detectChanges();
  }

  async getAddress(latitude, longitude) {
    try {
      const address = await this.googleMapsService.reverseGeocode({ lat: latitude, lng: longitude });
      this.address = address;
      this.statusButtonSave = false;
      this.cdr.detectChanges();
    } catch (error) {
      this.toastr.error('Geocoder failed: ' + error.message);
    }
  }

  saveNewAddress() {
    this.globalLatitud = this.latitud;
    this.globalLongitud = this.longitud;
    const newAddressBuilding = {
      modalAddress: {
        address: this.address,
        latitude: this.latitud,
        longitude: this.longitud,
      },
    };

    this.sendNewAddress.emit(newAddressBuilding);
    this.closeModal();
  }

  initLatLng() {
    this.marker = true;
    this.statusButtonSave = true;
    this.latitud = parseFloat(this.globalLatitud);
    this.longitud = parseFloat(this.globalLongitud);
    this.getAddress(this.latitud, this.longitud);
    this.zoom = 12;
  }

  openModal(content, windowClass: any) {
    if (this.latitud === '' && this.longitud === '') {
      this.initLatLng();
    }
    
    this.modalService.open(content, { windowClass: windowClass, backdrop: 'static', keyboard: false, size: 'xl' }).result.then(
      (result) => {
        this.closeModal();
      },
      (reason) => {},
    );
    
    this.styleModal(`.${windowClass}`);
    return false;
  }

  styleModal(clase: string) {
    setTimeout(() => {
      let modal = <HTMLElement>document.querySelector(`${clase} .modal-dialog`);
      if (modal) {
        modal.style.height = '-webkit-fill-available';
        modal.style.display = 'flex';
        modal.style.alignItems = 'center';
      }
    }, 1);
  }

  closeModal() {
    if (!this.address) {
      this.sendNewAddress.emit(null);
    }
    this.resetValues();
    this.modalService.dismissAll();
  }

  resetValues() {
    this.address = '';
    this.latitud = '';
    this.longitud = '';
  }

  openDropDown(selecter:NgSelectComponent, input:HTMLElement){
    if(this.possibleAddresses.length > 0){
      selecter.open();
      input.focus();
    }
  }

}
